<aside
  class="hidden lg:flex flex-col shrink-0 h-full bg-ppdms-secondary shadow-xl transition-all duration-300 ease-in-out"
  [class.w-64]="!collapsed"
  [class.w-16]="collapsed"
>
  <!-- ── Brand header ───────────────────────────────── -->
  <div
    class="py-3 px-4 h-fit flex shrink-0 items-center border-b border-slate-700/50"
    [class.justify-between]="!collapsed"
    [class.justify-center]="collapsed"
  >
    <!-- Logo mark -->
    <!-- <div
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-blue-500 shadow-md"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="h-4 w-4 text-white"
      >
        <path
          fill-rule="evenodd"
          d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
          clip-rule="evenodd"
        />
      </svg>
    </div> -->

    @if (!collapsed) {
      <div class="flex min-w-0 flex-col">
        <span class="truncate text-4xl font-bold text-white">PPDMS</span>
        <span
          class="truncate text-[10px] font-medium text-slate-400 uppercase tracking-wider"
        >
          {{ accountType === "ADMIN" ? "Admin Portal" : "User Portal" }}
        </span>
      </div>

      <!-- Collapse button -->
      <button
        type="button"
        (click)="toggleSidebar()"
        title="Collapse sidebar"
        class="ml-auto shrink-0 rounded-md p-1.5 text-slate-400 transition-colors hover:bg-slate-700 hover:text-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          class="h-4 w-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>
      </button>
    } @else {
      <span class="truncate text-xl font-bold text-white">P</span>
    }
  </div>

  <!-- ── Nav items ──────────────────────────────────── -->
  <nav
    class="flex flex-1 flex-col gap-2 overflow-y-auto overflow-x-hidden px-3 py-4 select-none"
  >
    @for (item of items; track item.label) {
      @if (item.children?.length) {
        <!-- Group -->
        <div>
          <button
            type="button"
            (click)="toggle(item)"
            [title]="collapsed ? item.label : ''"
            class="group w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-300 transition-colors hover:bg-slate-700/60 hover:text-white"
            [class.justify-center]="collapsed"
          >
            @if (item.icon) {
              <app-iconify-icon [icon]="item.icon"></app-iconify-icon>
            }

            @if (!collapsed) {
              <span class="flex-1 truncate text-left">{{ item.label }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2.5"
                stroke="currentColor"
                class="h-3.5 w-3.5 shrink-0 text-slate-500 transition-transform duration-200 group-hover:text-slate-300"
                [class.rotate-180]="isExpanded(item)"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg>
            }
          </button>

          @if (!collapsed && isExpanded(item)) {
            <div
              class="ml-4 mt-0.5 flex flex-col gap-0.5 border-l border-slate-700 pl-3"
            >
              @for (child of item.children; track child.label) {
                <a
                  [routerLink]="child.route"
                  routerLinkActive="bg-ppdms-primary text-white font-semibold"
                  [routerLinkActiveOptions]="{ exact: child.exact ?? false }"
                  class="flex items-center gap-2.5 rounded-md px-3 py-2 text-sm text-slate-400 transition-colors hover:bg-slate-700/60 hover:text-white"
                >
                  <span
                    class="h-1 w-1 shrink-0 rounded-full bg-current opacity-50"
                  ></span>
                  <span class="truncate">{{ child.label }}</span>
                  @if (child.badgeCount) {
                    <span
                      class="size-6 bg-red-600 text-white text-xs rounded-full flex items-center justify-center"
                    >
                      {{ child.badgeCount }}
                    </span>
                  }
                </a>
              }
            </div>
          }
        </div>
      } @else {
        <!-- Leaf -->
        <a
          [routerLink]="item.route"
          routerLinkActive="bg-ppdms-primary text-white"
          [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
          [title]="collapsed ? item.label : ''"
          class="group flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-300 transition-colors hover:bg-slate-700/60 hover:text-white"
          [class.justify-center]="collapsed"
        >
          @if (item.icon) {
            <app-iconify-icon [icon]="item.icon"></app-iconify-icon>
          }

          @if (!collapsed) {
            <span class="flex-1 truncate">{{ item.label }}</span>
            @if (item.badgeCount) {
              <span
                class="size-6 bg-red-600 text-white text-xs rounded-full flex items-center justify-center"
              >
                {{ item.badgeCount }}
              </span>
            }
          }
        </a>
      }
    }
  </nav>

  <!-- ── Footer ─────────────────────────────────────── -->
  <div class="shrink-0 border-t border-slate-700/50 p-3">
    @if (collapsed) {
      <!-- Expand button -->
      <button
        type="button"
        (click)="toggleSidebar()"
        title="Expand sidebar"
        class="flex w-full items-center justify-center rounded-md p-2 text-slate-400 transition-colors hover:bg-slate-700 hover:text-white"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          class="h-4 w-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M8.25 4.5l7.5 7.5-7.5 7.5"
          />
        </svg>
      </button>
    } @else {
      <!-- Logout -->
      <button
        (click)="logout()"
        type="button"
        class="group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-slate-400 transition-colors hover:bg-red-500/10 hover:text-red-400"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-5 w-5 shrink-0"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
          />
        </svg>
        <span>Sign out</span>
      </button>
    }
  </div>
</aside>
